"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _TermSelector = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/TermSelector"));

var _Tracking = require("pricing-pages-unified-ui/constants/Tracking");

var _Terms = require("self-service-api/constants/Terms");

var _CovidSelectors = require("../../selectors/CovidSelectors");

var _Editions = require("self-service-api/constants/Editions");

var _PromotionSelectors = require("../../selectors/PromotionSelectors");

var SuiteTermSelectorContainer = function SuiteTermSelectorContainer(_ref) {
  var activeTerm = _ref.activeTerm,
      activeEdition = _ref.activeEdition,
      onChange = _ref.onChange,
      getGrowthSuiteAvailableTerms = _ref.getGrowthSuiteAvailableTerms;
  var isCovidGrowthSuitePromoEligible = (0, _reactRedux.useSelector)(_CovidSelectors.isCovidGrowthSuitePromoEligibleSelector);
  var growthSuiteAvailableTerms = getGrowthSuiteAvailableTerms(isCovidGrowthSuitePromoEligible)[activeEdition];
  var hasTwoAvailableTerms = growthSuiteAvailableTerms[_Terms.MONTHLY] && growthSuiteAvailableTerms[_Terms.ANNUAL];
  var limitedToMonthlyTerm = isCovidGrowthSuitePromoEligible && activeEdition === _Editions.STARTER;
  return _react.default.createElement("div", null, _react.default.createElement(_TermSelector.default, {
    readOnly: !hasTwoAvailableTerms || limitedToMonthlyTerm,
    activeTerm: activeTerm,
    onChange: onChange,
    trackingSource: _Tracking.SUITE_CALCULATOR + "-" + activeEdition,
    isGrowthSuite: true
  }));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    getGrowthSuiteAvailableTerms: function getGrowthSuiteAvailableTerms(isCovidPromo) {
      return (0, _PromotionSelectors.growthSuiteAvailableTermsSelector)(state, isCovidPromo);
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(SuiteTermSelectorContainer);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/growth-suite-page/SuiteTermSelectorContainer.js
// module id = 869
// module chunks = 5 6